import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useGivenCansList, useRemoveGivenCans } from "../hooks";
import { useProducts } from "../../products/hooks";
import { useCustomers } from "../../customers/hooks";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";

interface IProps {
  productId?: number;
  customerId?: number;
}

export const GivenCansList: React.FC<IProps> = ({ productId, customerId }) => {
  const { data, loading, refetch } = useGivenCansList({ where: { productId, customerId } });
  const { data: productsData } = useProducts({ where: {}, limit: 100, offset: 0 });
  const { data: customersData } = useCustomers({ where: {} });
  const { data: meData } = useMe();
  const [remove] = useRemoveGivenCans();

  const isAdmin = meData?.me?.role === UserRole.Admin;

  const handleRemove = async (id: number) => {
    if (!window.confirm("Supprimer cette distribution ? Cette action est irréversible.")) return;
    await remove({ variables: { id } });
    refetch();
  };

  if (loading) return <Loading />;

  if (!data?.givenCansList?.results?.length) {
    return <EmptyList text="Aucune distribution gratuite" />;
  }

  const productName = (id: number | null) =>
    productsData?.products?.results?.find((product) => product.id === id)?.name ?? `#${id}`;
  const customerName = (id: number | null) =>
    customersData?.customers?.results?.find((customer) => customer.id === id)?.name ?? `#${id}`;

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          {!productId && <TableCell header>Produit</TableCell>}
          {!customerId && <TableCell header>Client</TableCell>}
          <TableCell header align="right">
            Quantité
          </TableCell>
          <TableCell header>Distribué par</TableCell>
          <TableCell header>Commentaire</TableCell>
          {isAdmin && <TableCell header align="center">Actions</TableCell>}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.givenCansList?.results?.map((givenCans) => (
          <TableRow key={`given-cans-${givenCans.id}`} hover={false}>
            {!productId && <TableCell>{productName(givenCans.productId)}</TableCell>}
            {!customerId && (
              <TableCell>
                {givenCans.customerId ? customerName(givenCans.customerId) : "-"}
              </TableCell>
            )}
            <TableCell align="right">{givenCans.quantity}</TableCell>
            <TableCell>
              {givenCans.givenBy
                ? `${givenCans.givenBy.firstname} ${givenCans.givenBy.lastname}`
                : "-"}
            </TableCell>
            <TableCell>{givenCans.comment || "-"}</TableCell>
            {isAdmin && (
              <TableCell align="center">
                <span
                  className="text-red-600 text-sm cursor-pointer hover:underline"
                  onClick={() => handleRemove(givenCans.id)}
                >
                  Supprimer
                </span>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
